import React, { Component } from 'react'
import style from './style.css'

export default class Text extends Component {
    mask(evt, mask){
        var src = evt.target
        src.value = src.value.replace(/[^\d]+/g,'')
        var ic = 0
        var value = ''
        
        for (var i = 0; i < mask.length; ++i) {
            const c = src.value.charAt(ic)
            const m = mask.charAt(i)
 
            if(c === '') break
            
            if(m !== '#') {
                value += m
            } else {          
                value += c
                ic++
            }
        }

        src.value = value

        if(this.props.handleChange) {
            this.props.handleChange({
                target: {
                    value,
                    name: this.props.name || ''
                }
            })
        }
    }

    render() {
        return (
            <div className={style.boxField}>
                <input
                    className={`${style.text} ${(this.props.transparent) ? style.transparent : ''} ${this.props.className || ''}`}
                    type='text'
                    
                    value={this.props.value}
                    defaultValue={this.props.defaultValue}
                    placeholder={this.props.placeholder || ''}

                    onKeyUp={this.props.mask ? (e) => this.mask(e, this.props.mask) : null}
                    onChange={this.props.handleChange || null}
                    name={this.props.name || ''}
                    disabled={this.props.disabled}
                    style={this.props.style || {}}
                    
                    />
                    {
                        (this.props.error)
                        ? <span className={style['error-icon']}>&#9888;</span>
                        : ''
                    }
                    {
                        (this.props.error)
                        ? <span className={style.error}>{this.props.error}</span>
                        : ''
                    }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/atoms/Forms/text.js